import React from 'react';
import { Modal } from 'antd';
import ReactMarkdown from 'react-markdown';

interface LegalDocumentModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
  version: string;
  content: string;
}

const LegalDocumentModal: React.FC<LegalDocumentModalProps> = ({
  open,
  onClose,
  title,
  version,
  content,
}) => {
  return (
    <Modal
      open={open}
      onCancel={onClose}
      title={`${title} — versión ${version}`}
      footer={null}
      width={720}
      centered
      styles={{
        body: {
          maxHeight: '70vh',
          overflowY: 'auto',
          paddingRight: 16,
        },
      }}
    >
      <div className="legal-document-content">
        <ReactMarkdown>{content}</ReactMarkdown>
      </div>
    </Modal>
  );
};

export default LegalDocumentModal;
